import React from "react";
import { i18n } from '../../translate/i18n';
import {
	Paper, Avatar, Typography, Checkbox,
} from "@mui/material";

import { renderStatusIcon, renderStatusColor } from '../../utils/statusManipulation';

export default function CardEquipment(props) {
  return (
    <Paper
			style={{
				...styles.card,
				border: `1px solid ${renderStatusColor(props)}`
			}}
			key={props._id}
			onClick={() => props.click(props._id)}
		>
      <div onClick={event => event.stopPropagation()} style={styles.headContainer}>
        <Checkbox
          style={styles.checkbox}
          size='small'
          checked={props.checked}
          onChange={() => props.checkbox(props)}
          disabled={props.statusGlobal === 'not defined'}
        />
				{renderStatusIcon(props)}
			</div>

      <div style={styles.fotoContainer}>
        {props.photo ? <Avatar src={props.photo.url} style={styles.avatar} /> : <Avatar style={styles.avatar}>{i18n.t('divCardEquipment.photo')}</Avatar>}
      </div>
      <Typography style={styles.labelsEquipModel}>{props.equipmentModel.name}</Typography>
      <Typography style={styles.labelsEquipGroup}>{props.equipmentModel.equipmentGroup.name}</Typography>
      <Typography style={styles.labelsEquipSerialNumber}>{props.serialNumber}</Typography>
    </Paper>
  )
}

const styles = {
	headContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'default'
	},
  checkbox: {
    margin: -10
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0.75rem',
    margin: '0.5rem',
    width: '11.60rem',
    cursor: 'pointer',
    flexGrown: 1
  },
  fotoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 0'
  },
  avatar: {
    width: '5rem',
    height: '5rem',
  },
  labelsEquipModel: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  labelsEquipModel: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  labelsEquipGroup: {
    fontSize: 12,
    marginBottom: 10,
  },
  labelsEquipSerialNumber: {
    fontSize: 12,
    color: 'grey',
  }
}